import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ViewProfileLayer from "../components/ViewProfileLayer";


const ViewProfilePage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>
        {/* ViewProfileLayer */}
        <ViewProfileLayer />

      </MasterLayout>

    </>
  );
};

export default ViewProfilePage; 
